import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { inject, observer } from 'mobx-react';
import { toJS } from 'mobx';

import { FiCheckCircle } from 'react-icons/fi';
import { Box, Container, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

import Greeting from '../../components/Greeting';

import RouterStore from '../../stores/RouterStore';

const successfullyCanceledStyles = {
  boxIcon: {
    maxWidth: '194px',
    margin: '0 auto',
  },
  boxText: {
    maxWidth: '480px',
    margin: '24px auto 40px auto',
    '& p': {
      fontSize: '16px',
    },
  },
};

class SuccessfullyCanceled extends Component {
  state = {
    customerName: '',
  };

  async componentDidMount() {
    const { routerStore } = this.props;
    const {
      location: { state },
    } = routerStore;

    const { customer } = toJS(state);

    this.setState({
      customerName: customer.name,
    });
  }

  render() {
    const { customerName } = this.state;
    const { classes } = this.props;

    return (
      <Box mt={5} mb={12}>
        <Container>
          <Greeting name={customerName} />
          <Box mt={5} mb={3} textAlign="center">
            <Box className={classes.boxIcon}>
              <FiCheckCircle size={90} color="#58C22E" />
            </Box>
            <Typography component="div">
              <Box fontSize={42} fontWeight="bold" mt={5}>
                Agendamento cancelado com sucesso.
              </Box>
            </Typography>
            <Box className={classes.boxText}>
              <Typography>
                Agora seu agendamento já está cancelado, não sendo mais possível
                agendar novamente por esse canal.
              </Typography>
              <br />
              <Typography>
                Se precisar de mais alguma informação, ligue no{' '}
                <strong>{process.env.REACT_APP_CENTRAL_PHONE_NUMBER}</strong>
              </Typography>
            </Box>
          </Box>
        </Container>
      </Box>
    );
  }
}

SuccessfullyCanceled.propTypes = {
  classes: PropTypes.object.isRequired,
  routerStore: PropTypes.instanceOf(RouterStore).isRequired,
};

export default withStyles(successfullyCanceledStyles)(
  inject('routerStore')(observer(SuccessfullyCanceled))
);
